angular.module('wbDirectives').directive 'scrollToLink', [ ->

    restrict: 'A'

    link: ( $scope, $element, $attrs ) ->

      $element.on "click", ->
        anchorValue = $attrs.href

        if anchorValue != undefined
          $("body,html").animate
            scrollTop: $(anchorValue).offset().top + 1
          , 400
]
